module.exports = "<p>\n  lock works!\n</p>\n"